import React from "react"
import avatar from "avatar/leri.svg"

const Leri = (props) => <img src={avatar} className="avatar" {...props} />

export default Leri
